<template>
    <div>
    </div>
</template>
<script>

  export default {
    name: "360ProjectReview",
    data() {
      return {
      }
    },
    methods: {
    },
    mounted() {
    }
  };
</script>
<style>
/* .header-class {
  padding-top: 110px !important;
} */
</style>
